export default __webpack_public_path__ + "static/media/IconDesc_ElectromagneticControlRod.256.768eaefc.png";